/**
 * Whether the given point falls within `rect`'s bounds. Returns `false` when `rect` is `null`
 * or `undefined`, so callers can pass a possibly-unmeasured element's `getBoundingClientRect()`
 * result straight through without a separate null check.
 */
export function isPointInRect(point: { x: number; y: number }, rect?: DOMRect | null): boolean {
  if (!rect) {
    return false
  }

  return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom
}
